module.exports = __webpack_public_path__ + "img/Auf_dem_Schulweg_1931.9c12174f.jpg";